import { PropsWithChildren } from 'react';

const StyledContainer = ({ children }: PropsWithChildren) => {
  return <div className="bg-brand-25 w-full h-full">{children}</div>;
};

export default StyledContainer;
